import { BankAccountSource } from '@features/bankAccounts/enums/bankAccountSource'
import { BankAccount } from '@features/bankAccounts/types/bankAccount'
import { OpenBankingAccount } from '@features/openBanking/types/openBankingAccount'
import { isOpenBankingAccountDeleted } from '@features/openBanking/utils/isOpenBankingAccountDeleted'
import { Account } from '@modules-deprecated/app/accounts/types'

export const getConnectedBookkeepingAccounts = (
  allAccounts: Account[],
  openBankingAccounts?: OpenBankingAccount[],
  bankAccounts?: BankAccount[],
): Account[] =>
  allAccounts.filter((account: Account) => {
    const openBankingAccount = openBankingAccounts?.find(
      (openBankingAccount) => openBankingAccount.externalAccountId === account.id,
    )
    const bankAccount = bankAccounts?.find((bankAccount) => bankAccount.bookkeepingAccountId === account.id)
    const isShineBankingAccount = bankAccount?.source === BankAccountSource.SHINE_BANKING
    const isActiveOpenBankingAccount = openBankingAccount && !isOpenBankingAccountDeleted(openBankingAccount)

    return (isShineBankingAccount || isActiveOpenBankingAccount) && !account.isArchived
  })
